module.exports = __webpack_public_path__ + "img/columns-03.73d19fcf.svg";